import { render, staticRenderFns } from "./handle-courses.vue?vue&type=template&id=6fe50bfa"
import script from "./handle-courses.vue?vue&type=script&lang=js"
export * from "./handle-courses.vue?vue&type=script&lang=js"
import style0 from "./handle-courses.vue?vue&type=style&index=0&id=6fe50bfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports